import { useState } from 'react';
// @mui
import {
  Stack,
  Typography,
  Divider,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import TimeRange from 'react-video-timelines-slider';
import { format } from 'date-fns';
import { DatePicker as AntdDatePicker } from 'antd';
import getTimelineGaps from '../../utils/getTimelineGaps';
import axiosInstance from '../../utils/axiosInstance';
import SingleSelector from '../single-selector/singleSelector';

const { RangePicker } = AntdDatePicker;

export default function DeleteVideos() {
  const { enqueueSnackbar } = useSnackbar();
  const [sensor, setSensor] = useState(null);
  const [timelines, setTimelines] = useState(null);
  const [openDialog, setOpenDialog] = useState(null);
  const [calendarStartDate, setCalendarStartDate] = useState(new Date());
  const [calendarEndDate, setCalendarEndDate] = useState(new Date());
  const [selectedInterval, setSelectedInterval] = useState([]);
  const [disabledIntervals, setDisabledIntervals] = useState([]);
  const [timelineScrubberError, setTimelineScrubberError] = useState(false);
  const sensorList = useSelector((state) => state.app.sensorList);

  const removeVideoDataApi = (jsonData) => {
    axiosInstance
      .delete(
        `${window.location.protocol}//${sensor.host}/api/v1/storage/file/${sensor.sensorId}?startTime=${jsonData.start_time}&endTime=${jsonData.end_time}` , { headers: { "streamId": sensor.sensorId } }
      )
      .then(async (response) => {
        enqueueSnackbar(
          `Success - deleted ${response.data.spaceSaved} MB of video data for sensor ${sensor.name}`,
          {
            variant: 'success',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          }
        );
        fetchTimelines(sensor);
      })
      .catch((error) => {
        if (error.response.data == null)
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        else
          enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
      });
  };

  const fetchTimelines = (sensor) => {
    if (!sensor) {
      return;
    }
    axiosInstance
      .get(`${window.location.protocol}//${sensor.host}/api/v1/record/${sensor.sensorId}/timelines`, { headers: { "streamId": sensor.sensorId } })
      .then(async (response) => {
        enqueueSnackbar(`Success - got timelines for ${sensor.name}`, {
          variant: 'success',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
        const timeline = response.data;
        console.log('timelines ', timeline);
        setTimelines(timeline);
        setDisabledIntervals(getTimelineGaps(timeline));
        if (timeline != null) {
          setSelectedInterval([new Date(timeline[0].startTime), new Date(timeline[timeline.length - 1].endTime)]);
        }
      })
      .catch((error) => {
        setTimelines(null);
        if (error.response.data == null)
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        else
          enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
      });
  };

  const onChangeCallback = (selectedInterval) => {
    console.log('selectedInterval', selectedInterval);
    setSelectedInterval(selectedInterval);
  };

  const timelineScrubberErrorHandler = ({ error }) => {
    if (error) {
      console.log('Selected timeline with gap !');
    }
    setTimelineScrubberError(error);
  };

  const handleClickTimelineOpen = () => {
    setOpenDialog('timeline');
  };

  const handleClickCalendarOpen = () => {
    console.log('yoo');
    setOpenDialog('calendar');
  };

  const handleCloseDialog = () => {
    setOpenDialog(null);
  };

  const handleDeleteUsingTimeline = () => {
    handleCloseDialog();
    enqueueSnackbar(`Pending - delete video files`, {
      variant: 'info',
      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    });
    if (!sensor) {
      enqueueSnackbar(`Error - Please select sensor`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    console.log('selectedInterval: ', selectedInterval);
    if (selectedInterval == null || selectedInterval.length === 0) {
      enqueueSnackbar(`Error - Please select valid interval`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    const jsonData = {
      start_time: selectedInterval[0] ? selectedInterval[0].toISOString() : '',
      end_time: selectedInterval[1] ? selectedInterval[1].toISOString() : '',
    };
    removeVideoDataApi(jsonData);
  };

  const handleDeleteUsingCalendar = () => {
    handleCloseDialog();
    enqueueSnackbar(`Pending - delete video files`, {
      variant: 'info',
      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    });
    if (!sensor) {
      enqueueSnackbar(`Error - Please select sensor`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    if (selectedInterval == null || selectedInterval.length === 0) {
      enqueueSnackbar(`Error - Please select valid interval`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    const jsonData = {
      start_time: calendarStartDate ? calendarStartDate.toISOString() : '',
      end_time: calendarEndDate ? calendarEndDate.toISOString() : '',
    };
    removeVideoDataApi(jsonData);
  };

  const handleSetSensor = (cam) => {
    setSensor(cam);
    fetchTimelines(cam);
    if (!cam) {
      setTimelines(null);
      setSelectedInterval([]);
      setDisabledIntervals([]);
    }
  };

  const handleDialogProceed = () => {
    if (openDialog === 'timeline') handleDeleteUsingTimeline();
    if (openDialog === 'calendar') handleDeleteUsingCalendar();
  };

  const onOkStartTime = (value) => {
    if (value.length > 0 && value[0]) setCalendarStartDate(value[0].toDate());
    if (value.length > 0 && value[1]) setCalendarEndDate(value[1].toDate());
  };

  return (
    <>
      <Dialog open={openDialog === 'timeline' || openDialog === 'calendar'} onClose={handleCloseDialog}>
        <DialogTitle>{'Do you want to proceed ? '}</DialogTitle>
        <DialogContent>
          <DialogContentText>Deleted video files will not be recoverable.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleDialogProceed} autoFocus>
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
      <Stack spacing={3} sx={{ mb: 2 }}>
        <SingleSelector
          id="delete-videos"
          placeholder="Type to search"
          label="Select sensor"
          value={sensor}
          onChange={handleSetSensor}
          getOptionLabel={(option) => {
            if (option.remoteDeviceName && option.remoteDeviceLocation) {
              return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
            } if (option.remoteDeviceName) {
              return `${option.name} at ${option.remoteDeviceName}`;
            }
            return option.name;

          }}
          options={sensorList}
        />
        {timelines != null && timelines.length > 0 && (
          <>
            <Divider sx={{ my: 2 }}>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                Select using timeline
              </Typography>
            </Divider>
            <Box className="scrubber">
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {`Selected range: ${selectedInterval.length > 0
                    ? `${format(selectedInterval[0], 'HH:mm:ss.SSS')} to ${format(selectedInterval[1], 'HH:mm:ss.SSS')}`
                    : 'range not selected'
                  }`}
              </Typography>

              <Box className="scrubber-container" sx={{ pt: 5, pb: 7, pl: 4, pr: 4 }}>
                <TimeRange
                  error={timelineScrubberError}
                  ticksNumber={3}
                  selectedInterval={selectedInterval}
                  timelineInterval={[
                    new Date(timelines[0].startTime),
                    new Date(timelines[timelines.length - 1].endTime),
                  ]}
                  onUpdateCallback={timelineScrubberErrorHandler}
                  onChangeCallback={onChangeCallback}
                  containerClassName="scrubber-container"
                  disabledIntervals={disabledIntervals}
                  step={1}
                  tooltipTag={'Time:'}
                  formatTick={(ms) => format(new Date(ms), 'MM/dd HH:mm:ss')}
                  formatTooltip={(ms) => format(new Date(ms), 'HH:mm:ss.SSS')}
                />
              </Box>
              <Box m={1} display="flex" justifyContent="flex-end" alignItems="flex-end">
                <LoadingButton size="large" type="submit" variant="contained" onClick={handleClickTimelineOpen}>
                  Delete
                </LoadingButton>
              </Box>
            </Box>
            <Box sx={{ zIndex: 999999, display: { xs: 'none', sm: 'none', md: 'inline' } }}>
              <Divider sx={{ my: 2 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  Select using calendar
                </Typography>
              </Divider>
              <RangePicker
                showTime={{ format: 'HH:mm:ss.SSS' }}
                format="YYYY-MM-DD HH:mm:ss.SSS"
                onOk={onOkStartTime}
              />
            </Box>
          </>
        )}
      </Stack>
      <Box
        m={1}
        display="flex"
        justifyContent="flex-end"
        alignItems="flex-end"
        sx={{ display: { xs: 'none', sm: 'none', md: 'flex' } }}
      >
        <LoadingButton size="large" type="submit" variant="contained" onClick={handleClickCalendarOpen}>
          Delete
        </LoadingButton>
      </Box>
    </>
  );
}
